
import styled from 'styled-components'

export const WhatIsAwazeTxt = styled.div`
  margin-right: 3rem;
`
